
import { supabase } from "@/integrations/supabase/client";
import { logClaudeApiInteraction } from "../logging/claudeApiLogger";

/**
 * Get word options using Claude
 */
export const getWordOptions = async (userWord: string, botWord: string, usedWordsArray: string[] = [], gameId?: string, roundNumber?: number) => {
  const startTime = Date.now();
  console.log(`Requesting word options for "${userWord}" and "${botWord}"`);
  console.log(`Used words count: ${usedWordsArray.length}`);
  
  // Prepare input for logging
  const input = {
    userWord,
    botWord,
    requestMultipleOptions: true,
    usedWords: usedWordsArray
  };
  
  try {
    const response = await supabase.functions.invoke('get-ai-word', {
      body: input
    });
    
    if (response.error) {
      console.error("Word options API error:", response.error);
      const errorMessage = response.error.message || 'Unknown error';
      
      // Determine specific fallback reason
      let fallbackReason = "API error";
      if (errorMessage.includes('overloaded') || errorMessage.includes('529')) {
        fallbackReason = "Claude API overloaded (service capacity limits)";
      } else if (errorMessage.includes('timeout') || errorMessage.includes('504')) {
        fallbackReason = "Claude API request timed out";
      } else {
        fallbackReason = `Claude API error: ${errorMessage}`;
      }
      
      console.warn(`${fallbackReason}. Will use fallback words.`);
      
      // Log error response
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'word_options',
        input,
        null,
        response.error,
        response.error.status || 500,
        startTime,
        true,
        fallbackReason
      );
      
      throw new Error(`Word options API error: ${errorMessage}`);
    }
    
    const wordOptions = response.data?.wordOptions || [];
    
    if (!Array.isArray(wordOptions) || wordOptions.length === 0) {
      const error = new Error("Invalid word options format or empty response");
      console.error("Invalid word options format or empty array");
      
      // Log invalid response
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'word_options',
        input,
        response.data,
        error,
        400,
        startTime,
        true,
        "Empty or invalid word options response"
      );
      
      throw error;
    }
    
    // Don't log successful responses - the Edge Function already did this
    return wordOptions;
  } catch (error) {
    console.error("Error getting word options:", error);
    
    // Only log errors that weren't already logged
    if (!(error instanceof Error && error.message.includes('Word options API error'))) {
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'word_options',
        input,
        null,
        error,
        500,
        startTime,
        true,
        `Unhandled error: ${error instanceof Error ? error.message : 'Unknown error'}`
      );
    }
    
    throw error; // Re-throw for retry logic
  }
};
